import React from 'react';

export const IconSparkle = ({ color }: { color: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="sparkle">
        <path
          id="Vector"
          d="M16.2166 6.66666L16.875 5.20833L18.3333 4.55C18.6583 4.4 18.6583 3.94166 18.3333 3.79166L16.875 3.13333L16.2166 1.66666C16.0666 1.34166 15.6083 1.34166 15.4583 1.66666L14.8 3.125L13.3333 3.78333C13.0083 3.93333 13.0083 4.39166 13.3333 4.54166L14.7916 5.2L15.45 6.66666C15.6 6.99166 16.0666 6.99166 16.2166 6.66666ZM9.58328 7.91666L8.25828 5C7.96662 4.35 7.03328 4.35 6.74162 5L5.41662 7.91666L2.49995 9.24166C1.84995 9.54166 1.84995 10.4667 2.49995 10.7583L5.41662 12.0833L6.74162 15C7.04162 15.65 7.96662 15.65 8.25828 15L9.58328 12.0833L12.5 10.7583C13.15 10.4583 13.15 9.53333 12.5 9.24166L9.58328 7.91666ZM15.45 13.3333L14.7916 14.7917L13.3333 15.45C13.0083 15.6 13.0083 16.0583 13.3333 16.2083L14.7916 16.8667L15.45 18.3333C15.6 18.6583 16.0583 18.6583 16.2083 18.3333L16.8666 16.875L18.3333 16.2167C18.6583 16.0667 18.6583 15.6083 18.3333 15.4583L16.875 14.8L16.2166 13.3333C16.0666 13.0083 15.6 13.0083 15.45 13.3333Z"
          fill={color}
        />
      </g>
    </svg>
  );
};
